<template>
	<div>
		<header-pago />
		<section-information
			message="TOKEN INVALIDO"
			message-down="Escribenos a:"
			invalid
		/>
	</div>
</template>
<script>
import headerPago from '@/components/pago/app-header';
import sectionInformation from '@/components/generate-app/section-information';

export default {
	name: 'section-invalid',
	components: {
		headerPago,
		sectionInformation,
	},
};
</script>


// WEBPACK FOOTER //
// src/components/generate-app/section-invalid.vue